import * as React from 'react';

import { dialogManager } from '../stores/DialogManager';

import { EmbedDialog } from './EmbedDialog';
import { ShareDialog } from './ShareDialog';
import { SimpleDialog } from './SimpleDialog';
import { SnapshotDialog } from './SnapshotDialog';
import { ModalIframe } from './iframe/ModalIframe';

import { CookieDialog } from '@egr/xbox/egr-gui-dialogs/cookieDialog/CookieDialog';

export const DefaultDialogs: React.FC = React.memo(
    () => {
        return (
            <React.Fragment>
                <SimpleDialog/>
                <ModalIframe key="modaliframe" />
                <CookieDialog openDataPrivacy={dialogManager.openDataPrivacy} openLegalNotice={dialogManager.openLegalNotice} key="cookiedialog" />
                <ShareDialog/>
                <EmbedDialog/>
                <SnapshotDialog/>
            </React.Fragment>
        );
    }
);